import Card from "@/atoms/account/Card";
import { CardTitle } from "../typography";
import Divider from "@/atoms/account/Divider";
import { useContext, useState } from "react";
import { AccountContext } from "contexts/AccountProvider";
import {
  FormikTextField,
  FormikForm,
  FormikSubmit,
  validateRequired,
} from "@/atoms/account/formik";
import PasswordChangeModal from "./PasswordChangeModal";
import TextFieldWithTrigger from "@/atoms/account/TextFieldWithTrigger";

const validationSchema = validateRequired(["email"]);

const AccountInformation = ({ initialValues, onSubmit, onSubmitPassword }) => {
  const [passwordModalOpen, setPasswordModalOpen] = useState(false);

  const onPasswordSuccess = () => {
    setPasswordModalOpen(false);
  };

  return (
    <Card>
      <FormikForm
        className={"grid gap-4"}
        onSubmit={onSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        <CardTitle>Account Information</CardTitle>
        <Divider />
        <div>
          <div className={"grid md:grid-cols-2 gap-x-4"}>
            <FormikTextField name={"firstName"} label={"First Name"} />
            <FormikTextField name={"lastName"} label={"Last Name"} />
          </div>
          <div className={"grid md:grid-cols-2 gap-x-4"}>
            <FormikTextField name={"email"} label={"Email"} />
            <FormikTextField
              name={"phone"}
              label={"Phone Number"}
              tooltip={
                <span className={"whitespace-nowrap"}>
                  Only used for account related communication.
                </span>
              }
              tooltipMinWidth={300}
            />
          </div>
          <TextFieldWithTrigger
            name={"password"}
            label={"Password"}
            triggerLabel={"Change Password"}
            triggerClassName={"text-error"}
            onTriggerClick={() => setPasswordModalOpen(true)}
            value={"password"}
            type={"password"}
            disabled
          />
        </div>
        <div>
          <FormikSubmit label={"Save Changes"} className={"float-right"} />
        </div>
      </FormikForm>
      <PasswordChangeModal
        isOpen={passwordModalOpen}
        onClose={() => setPasswordModalOpen(false)}
        onSubmit={onSubmitPassword}
        onSuccess={onPasswordSuccess}
      />
    </Card>
  );
};

const ConnectedAccountInformation = () => {
  const { user, updateUserProfile, changePassword } =
    useContext(AccountContext);
  const initialValues = {
    firstName: user?.firstName || "",
    lastName: user?.lastName || "",
    email: user?.email || "",
    phone: user?.phone || "",
  };

  const onSubmit = (values) =>
    updateUserProfile(values, {
      successMessage: "Successfully updated your profile",
    });

  const onSubmitPassword = (values) => changePassword({ values });

  return (
    <AccountInformation
      initialValues={initialValues}
      onSubmit={onSubmit}
      onSubmitPassword={onSubmitPassword}
    />
  );
};

export default ConnectedAccountInformation;
